import React from 'react'
import PropTypes from 'prop-types'
import getLabels from '../../utils/getLabels'

const CheckedInStatus = ({ classes, onCheckedInClicked, dataElement }) => {
  return (
    <div>
      {`${getLabels('status')}: `}
      <span className={classes.link} onClick={() => onCheckedInClicked()} data-element={dataElement} >
        {`${getLabels('checked_in')}`}
      </span>
    </div>
  )
}

CheckedInStatus.propTypes = {
  classes: PropTypes.shape({
    link: PropTypes.string,
  }),
  onCheckedInClicked: PropTypes.func.isRequired,
  dataElement: PropTypes.string,
}

export default CheckedInStatus
